import { adminRoutes } from 'src/routes'
import RoleLayout from './RoleLayout'

const AdminLayout = () => <RoleLayout allowedProfile="Admin" routes={adminRoutes} />

export default AdminLayout
